import { FaRupeeSign, FaHeadset } from "react-icons/fa";
import { MdCancel } from "react-icons/md";

export default function BenefitsBanner() {
  return (
    <div className="mb-6">
      <div className="bg-[#e9edf5] rounded-xl shadow-lg border border-gray-200 py-3 px-6 overflow-hidden transition-all duration-300 hover:shadow-xl">

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-blue-600">

          {/* Item 1 */}
          <div className="flex items-center gap-3 justify-center w-full">
            <div className="text-2xl flex-shrink-0">
              <FaRupeeSign />
            </div>
            <div>
              <p className="font-semibold text-base">
                Book Now
              </p>
              <p className="text-xs text-blue-500">
                at Zero Cost
              </p>
            </div>
          </div>

          {/* Item 2 */}
          <div className="flex items-center gap-3 justify-center w-full">
            <div className="text-2xl flex-shrink-0">
              <MdCancel />
            </div>
            <div>
              <p className="font-semibold text-base">
                Free Cancellations
              </p>
              <p className="text-xs text-blue-500">
                Upto 1 Hour
              </p>
            </div>
          </div>

          {/* Item 3 */}
          <div className="flex items-center gap-3 justify-center w-full">
            <div className="text-2xl flex-shrink-0">
              <FaHeadset />
            </div>
            <div>
              <p className="font-semibold text-base">
                24x7 Customer
              </p>
              <p className="text-xs text-blue-500">
                Support
              </p>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}
